/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  isFetching: false,
  defaultOptions: {},
  currentTeams: [],
  currentTeamIds: [],
  currentProducts: [],
  currentProductIds: [],
  // To know whether to disable DnD/ranking
  multipleProductsSelected: false,
  isSending: false,
  browserId: '',
  workPackageSearchText: ''
};

const defaultOptionsReducer = (state = initialState, action) => {
  const { team, teamId, product, productId } = action;
  const currentTeams = [...state.currentTeams];

  let updatedCurrentProducts;
  let updatedCurrentProductIds;
  let updatedCurrentTeams;
  let updatedCurrentTeamIds;

  let mappedTeams;
  let mappedProducts;
  const teamIndex =
    team && currentTeams.indexOf(currentTeams.find((ct) => ct.id === team.id));
  switch (action.type) {
    case Types.REQUEST_DEFAULT_OPTIONS:
      return { ...state, isFetching: true };
    // case Types.RECEIVE_DEFAULT_OPTIONS:
    //   return Object.assign({}, state, {
    //     isFetching: false,
    //     defaultOption: action.defaultOption,
    //   });
    case Types.RECEIVE_TEAM_DEFAULT_OPTIONS:
      // window.localStorage.setItem(
      //   'currentTeams',
      //   JSON.stringify(action.currentTeams)
      // );
      // window.localStorage.setItem(
      //   'currentProducts',
      //   JSON.stringify(action.currentProducts)
      // );
      return {
        ...state,
        isFetching: false,
        isSending: false,
        defaultOptions: action.defaultOptions,
        // currentTeams: action.currentTeams,
        // currentProducts: action.currentProducts,
        browserId: action.browserId
      };
    case Types.REQUEST_DEFAULT_OPTIONS_FAILED:
      return { ...state, isSending: false, isFetching: false };
    case Types.UPDATE_DEFAULT_OPTIONS:
      return { ...state, isSending: true };
    case Types.SET_CURRENT_TEAMS:
      return {
        ...state,
        currentTeams: action.currentTeams,
        currentTeamIds: action.currentTeamIds
      };
    case Types.SET_CURRENT_PRODUCTS:
      return {
        ...state,
        currentProducts: action.currentProducts,
        currentProductIds: action.currentProductIds,
        // To know whether to disable DnD/ranking
        multipleProductsSelected: action.currentProducts.length > 1
      };
    case Types.SET_CURRENT_PRIMARY:
      window.localStorage.setItem(
        'currentFilterPrimary',
        JSON.stringify(action.currentPrimary)
      );
      return {
        ...state,
        currentPrimary: action.currentPrimary
      };
    case Types.UPDATE_WORKPACKAGE_SEARCH_TEXT:
      return { ...state, workPackageSearchText: action.searchText };
    case Types.RESET_WORKPACKAGE_SEARCH_TEXT:
      return { ...state, workPackageSearchText: '' };
    case Types.UPDATE_TEAM_DEFAULT_OPTIONS:
      mappedTeams = state.currentTeams.map((t) => {
        if (t.id === team.id) {
          return { ...t, ...team };
        }
        return t;
      });

      // selected space is a team, products do not have teams
      mappedProducts = state.currentProducts.map((prod) => {
        if (!prod.teams) return prod;
        const newTeams = prod.teams.map((t) => {
          if (t.id === team.id) {
            delete team.products;
            return team;
          }
          return t;
        });
        return { ...prod, teams: newTeams };
      });

      return {
        ...state,
        currentTeams: mappedTeams,
        currentProducts: mappedProducts
      };

    case Types.ADD_CURRENT_PRODUCT:
      updatedCurrentProducts = [...state.currentProducts, product];
      updatedCurrentProductIds = [...state.currentProductIds, product.id];

      return {
        ...state,
        currentProducts: updatedCurrentProducts,
        currentProductIds: updatedCurrentProductIds
      };

    case Types.ADD_CURRENT_TEAM:
      updatedCurrentTeams = [...state.currentTeams, team];
      updatedCurrentTeamIds = [...state.currentTeamIds, team.id];

      return {
        ...state,
        currentTeams: updatedCurrentTeams,
        currentTeamIds: updatedCurrentTeamIds
      };

    case Types.REMOVE_CURRENT_TEAM:
      updatedCurrentTeams = state.currentTeams.filter((t) => t.id !== teamId);
      updatedCurrentTeamIds = state.currentTeamIds.filter(
        (id) => id !== teamId
      );

      return {
        ...state,
        currentTeams: updatedCurrentTeams,
        currentTeamIds: updatedCurrentTeamIds
      };

    case Types.REMOVE_CURRENT_PRODUCT:
      updatedCurrentProducts = state.currentProducts.filter(
        (p) => p.id !== productId
      );
      updatedCurrentProductIds = state.currentProductIds.filter(
        (id) => id !== productId
      );

      return {
        ...state,
        currentProducts: updatedCurrentProducts,
        currentProductIds: updatedCurrentProductIds
      };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false }
    default:
      return state;
  }
};

export default defaultOptionsReducer;
